
import {  useQuery } from "@apollo/client";
import { getReport } from "../../Utils/AllPagesQuriesAndMutations";

export function useGetPrintReport(options={}){
    const { data, loading, error, refetch } =
    useQuery(getReport, {
      fetchPolicy: "network-only",
      ...options,
    });
      // normalize return shape
  return {
    report: data?.Report?.[0],
    loading,
    error,
    refetch,
  };

}